export const generateKey = () => {
    return Math.ceil(Math.random() * 100000);
};
